import request from '@/utils/request';

/* eslint-disable */
const actions = {
  async getBundle({ dispatch, commit }, { uuid }) {
    try {
      await commit('updateIsLoading', { isLoading: true });

      this.isLoading = true;
      const { data } = await request.get(`/bundles/${uuid}`);

      if (data.error) {
        throw Error('Server-side validation failed');
      }

      await commit('setBundle', {
        bundle: data.bundle,
      });

      await commit('updateIsLoading', { isLoading: false });
    } catch (err) {
      await commit('updateIsLoading', { isLoading: false });

      throw err;
    }
  },

  async updateBundle({ dispatch, commit, rootGetters }, { uuid, bundle }) {
    try {
      const response1 = await request.put(`/bundles/${uuid}`, bundle);

      if (response1.data.error) {
        throw Error('Server-side validation failed');
      }

      const response2 = await request.get(`/bundles/${uuid}`);

      if (response2.data.error) {
        throw Error('Server-side validation failed');
      }

      await commit('updateBundle', {
        bundle: response2.data.bundle,
      });
    } catch (err) {
      throw err;
    }
  },
};

export default actions;
